<template>
  <v-card flat class="px-sm-5 pb-3">
    <v-row no-gutters justify="space-between">
      <span>
        <v-card-title> Charger booking </v-card-title>
      </span>
    </v-row>
    <!-- charger basic details -->
    <v-card-title>
      {{ charger.name }}
    </v-card-title>
    <v-card-subtitle opacity="1">
      {{ charger.addressString }}
    </v-card-subtitle>
    <v-card-text>
      <ul class="mb-5 text-body-1" style="list-style: none; padding-left: unset">
        <li>data provided by {{ charger.dataSrcDisplayStr }}</li>
        <li>{{ charger.evses.length }} devices</li>
        <li>
          {{ charger.simpleDisplayRating }}
        </li>
      </ul>
    </v-card-text>
    <!-- booking calendar -->
    <BookingCalendar :assetId="assetIds" :assetType="'charger'" :labels="labels" />
  </v-card>
</template>
<script setup lang="ts">
import type Charger from '@/classes/charger_classes/charger';
import { computed } from 'vue';
import BookingCalendar from '../booking/BookingCalendar.vue';

const { charger } = defineProps<{ charger: Charger }>()
const assetIds = computed(() => {
  const evseIds = charger.evses.map((evse) => evse.uid)
  if (evseIds.length > 1) return evseIds
  else if (evseIds.length === 1) return evseIds[0]
  return [charger.id] // this should never happen as a charger with no EVSEs will be discarded at the constructor step of processing fetched data into class objects.
})
const labels = computed(() => {
  if (charger.bookableEVSEDisplayData.length > 0) {
    const captureObj: { [key: string]: string } = {}
    for (const evse of charger.bookableEVSEDisplayData) {
      if (evse.display_name) captureObj[evse.evse_id] = evse.display_name
    }
    return captureObj
  }
  return undefined
})
</script>
